import { useEffect, useRef, useState } from "react";

/**
 * Vero per un attimo DOPO che lo stato di un conto e' cambiato da fuori.
 *
 * «Connetti» e «Disconnetti» stanno nello stesso punto della scheda: se il
 * conto cambia stato mentre il mouse sta li' (un aggiornamento in sottofondo,
 * il controllo delle sessioni, un altro operatore), il clic gia' partito
 * colpirebbe il pulsante opposto. Per questo istante i pulsanti di
 * collegamento sono spenti.
 */
export const SETTLE_MS = 1500;

export function useSettle(isConnected: boolean): boolean {
  const prev = useRef(isConnected);
  const [settling, setSettling] = useState(false);
  useEffect(() => {
    if (prev.current === isConnected) return;
    prev.current = isConnected;
    setSettling(true);
    const t = setTimeout(() => setSettling(false), SETTLE_MS);
    return () => clearTimeout(t);
  }, [isConnected]);
  return settling;
}
